exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.badge[data-v-29ec8fdc] {\n    cursor: pointer;\n}\nlabel[data-v-29ec8fdc] {\n    font-style: italic;\n}\n\n", ""]);

// exports
